// extracted by mini-css-extract-plugin
export default {"timelineAxisHeight":"72","gridRowHeight":"32"};